<script setup>
import {
  formatMoney, formatNumber, formatSignedMoney, formatSignedPercent, signClass, toNumber,
} from '../format';
import { t } from '../i18n';
import { PANEL } from '../ui';

// «У вас» of the instrument screen (docs/instrument/SPEC.md, decisions 7, 18): a block per account that holds it.
defineProps({
  // [{ key, account, position, value, current, yieldAbs, yieldPercent }]
  holdings: {
    type: Array,
    required: true,
  },
});
</script>

<template>
  <div class="space-y-3 sm:space-y-4">
    <section
      v-for="holding in holdings"
      :key="holding.key"
      :class="PANEL"
    >
      <h2 class="flex items-baseline justify-between gap-3 text-[0.9375rem] font-semibold text-slate-100">
        <span class="min-w-0 truncate">{{ holding.account }}</span>
        <span class="shrink-0 tabular-nums">{{ t('portfolio.pcs', { n: formatNumber(holding.position.quantity) }) }}</span>
      </h2>
      <dl class="mt-2 divide-y divide-slate-800 text-[0.9375rem] sm:text-sm">
        <div class="flex min-h-11 items-center justify-between gap-3">
          <dt class="text-slate-400">
            {{ t('instrument.value') }}
          </dt>
          <dd class="tabular-nums text-slate-100">
            {{ formatMoney(holding.value, holding.position.currency) }}
          </dd>
        </div>
        <div
          v-if="toNumber(holding.position.average_price)"
          class="flex min-h-11 items-center justify-between gap-3"
        >
          <dt class="text-slate-400">
            {{ t('instrument.average') }}
          </dt>
          <dd
            class="tabular-nums text-slate-100"
            :title="toNumber(holding.position.average_price_fifo) ? t('portfolio.fifo', { price: formatMoney(holding.position.average_price_fifo, holding.position.currency) }) : undefined"
          >
            {{ formatMoney(holding.position.average_price, holding.position.currency) }} → {{ formatMoney(holding.current, holding.position.currency) }}
          </dd>
        </div>
        <div
          v-if="holding.yieldAbs !== null && holding.position.instrument_type !== 'currency'"
          class="flex min-h-11 items-center justify-between gap-3"
        >
          <dt class="text-slate-400">
            {{ t('instrument.profit') }}
          </dt>
          <dd
            class="tabular-nums"
            :class="signClass(holding.yieldAbs)"
          >
            {{ formatSignedMoney(holding.yieldAbs, holding.position.currency) }}<template v-if="holding.yieldPercent !== null">
              · {{ formatSignedPercent(holding.yieldPercent) }}
            </template>
          </dd>
        </div>
      </dl>
      <p
        v-if="holding.position.blocked"
        class="mt-2 text-[0.8125rem] text-amber-300"
      >
        {{ t('portfolio.blocked') }}
      </p>
      <p
        v-if="holding.position.outside_total"
        class="mt-2 text-[0.8125rem] text-slate-500"
      >
        {{ t('portfolio.outsideTotalHint') }}
      </p>
    </section>
  </div>
</template>
